var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionActionButton } from "./actionHudActionButton";
import { mapActionButton } from "./mapActionButton";
var initial = {
    actionButtonIterations: new Map(),
    currentActionButton: undefined,
};
export var reducerActionButtonIterations = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionActionButton.AddIteration) {
        var currentActionButton = mapActionButton.get(action.actionButtonId);
        var previousIterations = state.actionButtonIterations.get(action.actionButtonId) || 0;
        state.actionButtonIterations.set(action.actionButtonId, previousIterations + 1);
        return __assign({}, state, { currentActionButton: currentActionButton });
    }
    else if (action.type === TypeActionActionButton.ResetIterations) {
        state.actionButtonIterations.set(action.actionButtonId, 0);
        return __assign({}, state, { currentActionButton: undefined });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/reducerActionButtons.ts
// module id = 2531
// module chunks = 3